"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceTransparencyWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var PriceTransparencyChart_1 = require("./PriceTransparencyChart");
var PriceTransparencyCarousel_1 = require("./PriceTransparencyCarousel");
var reactstrap_1 = require("reactstrap");
var PriceTransparencyWidget = /** @class */ (function (_super) {
    __extends(PriceTransparencyWidget, _super);
    function PriceTransparencyWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.minValue = 10;
        _this.maxValue = 50;
        _this.prepareData = function () {
            var addressValue = _this.props.vehicles
                .map(function (vehicle) { return (vehicle.mlOutputData && vehicle.mlOutputData.l1_Location) ? vehicle.mlOutputData.l1_Location : 0; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            var coverValue = _this.props.vehicles
                .map(function (vehicle) { return (vehicle.mlOutputData && vehicle.mlOutputData.l1_Cover) ? vehicle.mlOutputData.l1_Cover : 0; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            var driverValue = _this.props.vehicles
                .map(function (vehicle) { return (vehicle.mlOutputData && vehicle.mlOutputData.l1_Who) ? vehicle.mlOutputData.l1_Who : 0; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            var carValue = _this.props.vehicles
                .map(function (vehicle) { return (vehicle.mlOutputData && vehicle.mlOutputData.l1_Vehicle) ? vehicle.mlOutputData.l1_Vehicle : 0; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            var textForAddress = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["We\u2019ll take into account the local population, levels of vehicle crime and where you park your car.", (0, jsx_runtime_1.jsxs)("b", { children: [" Your address ", addressValue > 0 ? "increased" : "decreased", " your price."] })] }));
            var textForCover = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Your cover, excess and any optional extras you have will affect you premium.", (0, jsx_runtime_1.jsxs)("b", { children: [" Your choice of cover ", coverValue > 0 ? "increased" : "decreased", " your price."] })] }));
            var textForDriver = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Your age, claims history, and driving experience affect how much you pay.", (0, jsx_runtime_1.jsxs)("b", { children: [" Driver details ", driverValue > 0 ? "increased" : "decreased", " your price."] })] }));
            var textForCar = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["The model, engine size and cost of your car will affect your premium.", (0, jsx_runtime_1.jsxs)("b", { children: [" Your car ", carValue > 0 ? "increased" : "decreased", " your price."] })] }));
            return [
                { name: "Address", value: _this.setMinMaxValue(addressValue), description: textForAddress },
                { name: "Cover", value: _this.setMinMaxValue(coverValue), description: textForCover },
                { name: _this.props.isMultipleDrivers ? "Drivers" : "Driver", value: _this.setMinMaxValue(driverValue), description: textForDriver },
                { name: _this.props.vehicles.length > 1 ? "Cars" : "Car", value: _this.setMinMaxValue(carValue), description: textForCar }
            ];
        };
        _this.setMinMaxValue = function (value) {
            var minValue = _this.minValue * _this.props.vehicles.length;
            var maxValue = _this.maxValue * _this.props.vehicles.length;
            if (value > 0 && value < minValue) {
                return minValue;
            }
            else if (value < 0 && value > -minValue) {
                return -minValue;
            }
            else if (value > maxValue) {
                return maxValue;
            }
            else if (value < -maxValue) {
                return -maxValue;
            }
            else {
                return value;
            }
        };
        _this.setActiveIndex = function (index) { return _this.setState({ activeIndex: index }); };
        _this.toggle = function () { return _this.setState({ isModalOpen: !_this.state.isModalOpen }); };
        _this.state = {
            activeIndex: 3,
            isModalOpen: false
        };
        return _this;
    }
    PriceTransparencyWidget.prototype.render = function () {
        if (this.props.vehicles && this.props.vehicles.length > 0) {
            var data = this.prepareData();
            if (data.every(function (d) { return d.value === 0; })) {
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            }
            else {
                return ((0, jsx_runtime_1.jsxs)("div", { className: "price-transparency-widget _panel rounded bg-white-blue m-0 p-0 " + this.props.className, children: [(0, jsx_runtime_1.jsxs)("div", { className: "cursor-pointer d-flex p-3", onClick: this.toggle, children: [(0, jsx_runtime_1.jsx)("img", { className: "mr-3", src: "/img/Flow-info.svg", alt: "Price transparency info" }), (0, jsx_runtime_1.jsxs)("div", { className: "line-height-15", children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold font-family-display", children: "How do we calculate your price? " }), (0, jsx_runtime_1.jsx)("span", { className: "text-decoration-underline text-blue-1 font-weight-extra-light", children: "Please check the factors that influence your price" })] })] }), (0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "price-transparency-modal", isOpen: this.state.isModalOpen, toggle: this.toggle, centered: true, fade: false, scrollable: true, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: this.toggle, close: (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.toggle }), children: (0, jsx_runtime_1.jsx)("div", { className: "pt-4 text-center text-blue-2 font-weight-bold font-family-display fs-18", children: "Factors affecting your price" }) }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalBody, { className: "p-0", children: [(0, jsx_runtime_1.jsx)(PriceTransparencyChart_1.PriceTransparencyChart, { className: "mt-2 mx-2", data: data, activeIndex: this.state.activeIndex, setActiveIndex: this.setActiveIndex }), (0, jsx_runtime_1.jsx)(PriceTransparencyCarousel_1.PriceTransparencyCarousel, { className: "mt-5 mb-5", data: data, activeIndex: this.state.activeIndex, setActiveIndex: this.setActiveIndex })] })] })] }));
            }
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    return PriceTransparencyWidget;
}(React.Component));
exports.PriceTransparencyWidget = PriceTransparencyWidget;
//# sourceMappingURL=PriceTransparencyWidget.js.map